angular.module('ecrd.notifications', []);